"use client"

import {
  ACTIVITIES_URI,
  Box,
  Link,
  MessageChannel,
  P,
  PROFILE_URI,
  TextButton,
  useUser,
} from "@bullseye/components"

import { MessengerChannelIcon } from "../MessengerChannelIcon"

export function MessageChannelTitle({
  messageChannel,
}: {
  messageChannel?: MessageChannel
}) {
  const { user: dmUser } = useUser(
    !messageChannel?.experience_id ? messageChannel?.dm_user?.id : undefined,
  )

  if (!messageChannel) return null

  const title = messageChannel?.pretty_title || "Hank Member"
  const link = messageChannel.experience
    ? `${ACTIVITIES_URI}/${messageChannel.experience.slug}`
    : `${PROFILE_URI}/${messageChannel.dm_user?.slug}`
  const avatarUrl =
    dmUser?.avatar?.url || messageChannel?.dm_user?.avatar?.url || messageChannel?.dm_user?.avatar_url

  return (
    <Box className="flex flex-row items-center g-2">
      <Link href={link} className="flex flex-col items-center justify-center">
        <MessengerChannelIcon
          isSuspended={messageChannel?.dm_user?.is_suspended}
          isExperience={!!messageChannel?.experience}
          isGroupChat={
            messageChannel?.is_group_message && !messageChannel?.experience
          }
          imageUrl={messageChannel?.experience?.cover_photo?.url || avatarUrl}
          title={title}
          size="sm"
        />
      </Link>
      <TextButton as="a" href={link}>
        <P bold ellipsis>
          {title}
        </P>
      </TextButton>
    </Box>
  )
}
